import { render, staticRenderFns } from "./doorManager.vue?vue&type=template&id=b875aac0"
import script from "./doorManager.vue?vue&type=script&lang=js"
export * from "./doorManager.vue?vue&type=script&lang=js"
import style0 from "./doorManager.vue?vue&type=style&index=0&id=b875aac0&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports